export default __webpack_public_path__ + "static/media/icon-close.62d4c62b.svg";